import React from "react";
import DashboardIcon from "../images/navbar/dashboard_icon.svg";
import VehicleIcon from "../images/navbar/vehicle_icon.svg";
import RouteIcon from "../images/navbar/route_icon.svg";
import StopIcon from "../images/navbar/stop_icon.svg";
import AlertsIcon from "../images/navbar/alert_icon.svg";
import ScheduleIcon from "../images/navbar/schedule_icon.svg";
import DriverIcon from "../images/navbar/driver_icon.svg";
import SiteIcon from "../images/navbar/sites_icon.svg";
import UserIcon from "../images/navbar/users_icon.svg";
import ReportsIcon from "../images/navbar/manageData_icon.svg";
import OrganizationIcon from "../images/navbar/Organization_icon.svg";
import FeatureIcon from "../images/navbar/feaure_icon.svg";
import DeviceIcon from "../images/navbar/device_icon.svg";
import SettingsIcon from "../images/navbar/settings.svg";
import AddIcon from "../images/navbar/navbar_dropdown/add_icon.svg";
import ViewIcon from "../images/navbar/navbar_dropdown/view_all_icon.svg";
import SchoolDashboardIcon from "../images/schoolTracking/navmenu/dashboard.svg";
import SchoolStudentIcon from "../images/schoolTracking/navmenu/students.svg";
import SchoolVehicleIcon from "../images/schoolTracking/navmenu/vehcile.svg";
import SchoolAttendantIcon from "../images/schoolTracking/navmenu/attendant.svg";
import SchoolRouteIcon from "../images/schoolTracking/navmenu/routes.svg";
import SchoolStopIcon from "../images/schoolTracking/navmenu/stops.svg";
import SchoolDriverIcon from "../images/schoolTracking/navmenu/driver.svg";
import SchoolAnalyticsIcon from "../images/schoolTracking/navmenu/report.svg";

const NAV_ICON_SRC_BY_KEY = {
  "fleet.nav.dashboard": DashboardIcon,
  "fleet.nav.vehicle": VehicleIcon,
  "fleet.nav.route": RouteIcon,
  "fleet.nav.stop": StopIcon,
  "fleet.nav.alert": AlertsIcon,
  "fleet.nav.schedule": ScheduleIcon,
  "fleet.nav.driver": DriverIcon,
  "fleet.nav.attendant": SchoolAttendantIcon,
  "fleet.nav.site": SiteIcon,
  "fleet.nav.user": UserIcon,
  "fleet.nav.organization": OrganizationIcon,
  "fleet.nav.feature": FeatureIcon,
  "fleet.nav.device": DeviceIcon,
  "fleet.nav.reports": ReportsIcon,
  "fleet.nav.settings": SettingsIcon,
  "fleet.nav.add": AddIcon,
  "fleet.nav.view": ViewIcon,
  "school.nav.dashboard": SchoolDashboardIcon,
  "school.nav.students": SchoolStudentIcon,
  "school.nav.vehicles": SchoolVehicleIcon,
  "school.nav.attendants": SchoolAttendantIcon,
  "school.nav.routes": SchoolRouteIcon,
  "school.nav.stops": SchoolStopIcon,
  "school.nav.drivers": SchoolDriverIcon,
  "school.nav.schedules": ScheduleIcon,
  "school.nav.sites": SiteIcon,
  "school.nav.users": UserIcon,
  "school.nav.analytics": SchoolAnalyticsIcon,
  "school.nav.alert": AlertsIcon,
  "school.nav.settings": SettingsIcon,
};

export function getNavIcon(iconKey, alt = "Nav icon") {
  const src = NAV_ICON_SRC_BY_KEY[iconKey];
  if (!src) return null;
  return <img src={src} alt={alt} />;
}
